import { createFileRoute } from '@tanstack/react-router';
import DashboardTemplate from '@/features/agent/dashboard/templates/DashboardTemplate';

export const Route = createFileRoute('/agent/')({
  component: Dashboard,
  staticData: { title: 'ダッシュボード' },
});

function Dashboard() {
  return <DashboardTemplate />;
}
